module.exports = __webpack_public_path__ + "static/img/detail-wikiW.eed29269.png";